import React from 'react';

import { CloseIcon } from '@icons';
import gtmTracker from '@utils/gtmTracker';

import { Category, ShopFiltersState } from '@types';

import { config } from '@/config.ts';

import * as Styled from './category-chip.styled';

type OwnProps = {
	category: Category;
	filtersState: ShopFiltersState;
	categoryToggle: (id: string) => void;
	isLoading: boolean;
};

const CategoryChip: React.FC<OwnProps> = ({ category, filtersState, categoryToggle, isLoading }) => {
	const isPmBrand = config.BRAND === 'pm';

	const handleClick = () => {
		gtmTracker.trackEvent('click', {
			event_category: 'Shop_chips',
			event_action: 'click',
			event_label: category.name
		});
		categoryToggle(category.id);
	};

	return (
		<Styled.CategoryChip
			key={category.id}
			$selected={filtersState.selectedCategories.includes(category.id)}
			$disabled={isLoading}
			onClick={handleClick}
			$round={!isPmBrand}
		>
			{category.image_url && (
				<Styled.IconWrapper>
					<Styled.IconImg src={category.image_url} alt='category_icon' />
				</Styled.IconWrapper>
			)}
			<Styled.CategoryName>{category.name}</Styled.CategoryName>

			<Styled.ChipCloseIcon $visible={filtersState.selectedCategories.includes(category.id)}>
				<CloseIcon.Rounded />
			</Styled.ChipCloseIcon>
		</Styled.CategoryChip>
	);
};

export default CategoryChip;
